import {
    faAt,
    faCalendar,
    faCheck,
    faPause,
    faPlay,
    faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { ColumnDescription } from "react-bootstrap-table-next";
import { FormProvider, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import {
    ReagendarCasoVistoriaController,
    ParalisarCasoVistoriaController,
    AdcorpusCasoVistoriaController,
    ListarVistoriasController,
    IniciarCasoVistoriaController,
    ReenvioEmailController,
    ReiniciarCasoVistoriaController,
    LiberacaoCasosVistoriaEmMassaController,
} from "../../../Controllers/Vistorias/GestaoDeVistorias/GestaoDeVistoriasControllers";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import {
    IGestaoDeEntregaChavesRequest,
    IGestaoVistoriaResponse,
} from "../../../Interfaces/Vistorias/VistoriaEntregaDeChaves/GestaoDeEntregaChaves";
import { ACESSOS } from "../../../Routes/Acessos";
import StorageManagerCapys from "../../../Tools/Storage";
import FiltroEntregaChaves from "../GestaoAtendimentos/FiltrosEntregaChaves";
import UnForm from "../../../Components/Form";
import { MotivoNaoProcedenciaController } from "../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import { IPropsTableChange } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import Swal from "sweetalert2";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import moment from "moment";
import GerarDocumentoGestaoVistoria from "../GerarDocumentoGestaoVistoria";
import { useUserInfor } from "../../../Context/User";

export default function GestaoVistoriaEntregaChaves() {
    const FormMethods = useForm();
    const { PageFilter, filter, setPageFilter, setPage, setFilter } =
        usePaginationFilter<IGestaoDeEntregaChavesRequest>({ page: 1 });
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const filterStorage = new StorageManagerCapys<IGestaoVistoriaResponse>(
        "FILTRO_GESTAO_VISTORIA"
    );
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number>(
        ""
    );
    const [lstSelecionados, setLstSelecionados] = useState<
        IGestaoVistoriaResponse | undefined
    >();

    const adicionaPlural =
        (lstSelecionados?.Vistorias.length ?? 0) > 1 ? "s" : "";

    const mappedVistorias = lstSelecionados?.Vistorias?.map((selecionados) => {
        if (selecionados) {
            return {
                ID_CONTA: selecionados.ID_CONTA ? selecionados.ID_CONTA : 0,
                ID_CONTATO: selecionados.ID_CONTATO
                    ? selecionados.ID_CONTATO
                    : 0,
                ID_PRODUTO: selecionados.ID_PRODUTO
                    ? selecionados.ID_PRODUTO
                    : 0,
            };
        }
        return null;
    });

    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const filteredVistorias = mappedVistorias?.filter(
        (vistoria) => vistoria !== null
    ) as { ID_PRODUTO: number; ID_CONTA: number; ID_CONTATO: number }[];

    const {
        execute: LiberacaoCasosVistoriaEmMassa,
        loading: LiberacaoCasosVistoriaEmMassaLoading,
    } = useAsyncCallback(LiberacaoCasosVistoriaEmMassaController);

    const { execute: ReagendarCaso, loading: ReagendarLoading } =
        useAsyncCallback(ReagendarCasoVistoriaController);

    const { execute: EnviarEmail, loading: enviarEmailLoading } =
        useAsyncCallback(ReenvioEmailController);

    const { execute: ParalisarCaso, loading: ParalisarLoading } =
        useAsyncCallback(ParalisarCasoVistoriaController);

    const { execute: ReiniciarCaso, loading: ReiniciarLoading } =
        useAsyncCallback(ReiniciarCasoVistoriaController);

    const { execute: AdcorpusCaso, loading: AdcorpusLoading } =
        useAsyncCallback(AdcorpusCasoVistoriaController);

    const { execute: IniciarCaso, loading: IniciarCasoLoading } =
        useAsyncCallback(IniciarCasoVistoriaController);

    const [pesquisaText, setPesquisaText] = useState("");

    const {
        value: listarFormulariosVistoria,
        loading: listarFormulariosVistoriaLoading,
        execute: updateList,
    } = useAsyncEffect(
        async () =>
            ListarVistoriasController(PageFilter.page, { ...filter } ?? {}),
        [PageFilter.filter, PageFilter.page]
    );

    const totalPaginas = listarFormulariosVistoria?.NR_PAGINAS;

    const atendimentoVistoriaColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO",
            text: "",
            isDummyField: true,
            formatter: vistoriaFormatter,
            headerClasses: "d-none",
        },
    ];

    function vistoriaFormatter(
        cell: any,
        row: IGestaoVistoriaResponse["Vistorias"][0]
    ) {
        return (
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    {row.ID_CASO ? (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-atendimento-tooltip">
                                    Ver Atendimento
                                </Tooltip>
                            }
                        >
                            <Link
                                to={ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTO.DS_LINK(
                                    row.ID_CASO || 0
                                )}
                                className="btn btn-info"
                            >
                                <i className="far fa-eye"></i> Ver Atendimento
                            </Link>
                        </OverlayTrigger>
                    ) : null}
                    <div>
                        <span>
                            <strong>Caso Vistoria:</strong> {row.ID_CASO}
                        </span>
                    </div>
                </div>
                <div className="card-body d-flex justify-content-between">
                    <div className="d-flex flex-column">
                        <div>
                            <span>
                                <strong>EMPREENDIMENTO:</strong>{" "}
                                {row.DS_EMPREENDIMENTO}
                            </span>
                        </div>
                        <div>
                            <span>
                                <strong>UNIDADE:</strong> {row.DS_UNIDADE}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-column">
                        <div>
                            <span>
                                <strong>CLIENTE:</strong> {row.DS_NOME}
                            </span>
                        </div>
                        <div>
                            <span>
                                <strong>ETAPA:</strong> {row.DS_ETAPA}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="card-footer d-flex justify-content-end">
                    {row.ID_CASO ? null : (
                        <>
                            <button
                                className="btn btn-dark font-weight-bold mr-2"
                                disabled={IniciarCasoLoading}
                                onClick={() => {
                                    IniciarCaso(
                                        row.ID_PRODUTO,
                                        row.ID_CONTA,
                                        row.ID_CONTATO
                                    ).then(() => {
                                        updateList();
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faPlay} /> Iniciar
                                Processo
                            </button>
                            <button
                                className="btn btn-dark font-weight-bold"
                                disabled={AdcorpusLoading}
                                onClick={() => {
                                    AdcorpusCaso(
                                        row.ID_PRODUTO,
                                        row.ID_CONTA,
                                        row.ID_CONTATO
                                    ).then(() => {
                                        updateList();
                                    });
                                }}
                            >
                                Ad Corpus
                            </button>
                        </>
                    )}
                    {!row.ID_CASO || !row.ID_MOTIVO_NAO_PROCEDENCIA ? (
                        <button
                            className="btn btn-warning font-weight-bold mr-2"
                            disabled={ParalisarLoading}
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Paralisar Caso",
                                    IconHeader: faPause,
                                    Component: () => (
                                        <>
                                            <UnForm
                                                handleSubmit={(formData) => {
                                                    ParalisarCaso(
                                                        row.ID_CASO,
                                                        formData.ID_MOTIVO_NAO_PROCEDENCIA
                                                    ).then(() => {
                                                        updateList();
                                                        setShow(false);
                                                    });
                                                }}
                                            >
                                                <UnForm.LazySelect
                                                    label="Motivo Não Procedência"
                                                    name="ID_MOTIVO_NAO_PROCEDENCIA"
                                                    controller={() =>
                                                        MotivoNaoProcedenciaController(
                                                            row.ID_CASO
                                                        )
                                                    }
                                                    getDS={(ca) =>
                                                        ca.DS_MOTIVO_NAO_PROCEDENCIA
                                                    }
                                                    getKeyValue={(p) =>
                                                        p.ID_MOTIVO_NAO_PROCEDENCIA
                                                    }
                                                    registerOptions={{
                                                        required:
                                                            "Insira um motivo antes de paralisar",
                                                        valueAsNumber: true,
                                                    }}
                                                    className="form-control mb-2"
                                                />
                                                <button className="btn btn-success w-100 mt-3">
                                                    Paralisar
                                                </button>
                                            </UnForm>
                                        </>
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faPause} /> Paralisar
                        </button>
                    ) : (
                        <button
                            className="btn btn-primary font-weight-bold mr-2 cursor-default"
                            disabled={ReiniciarLoading}
                            onClick={() => {
                                ReiniciarCaso(row.ID_CASO).then(() => {
                                    updateList();
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faPlay} /> Reiniciar
                        </button>
                    )}
                    {row.DT_FIM === null ? (
                        <button
                            className="btn btn-danger font-weight-bold mr-2"
                            disabled={ReagendarLoading}
                            onClick={() => {
                                ReagendarCaso(row.ID_CASO).then(() => {
                                    updateList();
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faCalendar} /> Reagendar
                        </button>
                    ) : (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="overlay-tooltip">
                                    Atendimento finalizado
                                </Tooltip>
                            }
                        >
                            <span className="d-inline-block">
                                <Button
                                    className="btn btn-danger font-weight-bold mr-2"
                                    disabled={row.DT_FIM !== null}
                                    style={{ pointerEvents: "none" }}
                                >
                                    <FontAwesomeIcon icon={faCalendar} />{" "}
                                    Reagendar
                                </Button>
                            </span>
                        </OverlayTrigger>
                    )}
                    <button
                        className="btn btn-success font-weight-bold"
                        disabled={enviarEmailLoading}
                        onClick={() => {
                            EnviarEmail(row.ID_CASO).then(() => {
                                updateList();
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faAt} /> Reenviar Email
                    </button>
                </div>
            </div>
        );
    }

    const tableviewColumns: Array<
        ColumnDescription<IGestaoVistoriaResponse["Vistorias"][0]>
    > = [
        {
            dataField: "Ver Caso",
            text: "",
            isDummyField: true,
            formatter: (_, row) => {
                return row.ID_CASO ? (
                    <>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-atendimento-tooltip">
                                    Ver Atendimento
                                </Tooltip>
                            }
                        >
                            <Link
                                to={ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTO.DS_LINK(
                                    row.ID_CASO || 0
                                )}
                                className="m-2 btn btn-icon btn-outline-info"
                            >
                                <i className="icon-xl far fa-eye"></i>
                            </Link>
                        </OverlayTrigger>
                    </>
                ) : (
                    <span></span>
                );
            },
        },
        {
            dataField: "ID",
            text: "",
            isDummyField: true,
        },
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "EMPREENDIMENTO",
        },
        {
            dataField: "DS_UNIDADE",
            text: "UNIDADE",
        },
        {
            dataField: "DS_NOME",
            text: "CLIENTE",
        },
        {
            dataField: "ID_CASO",
            text: "CASO VISTORIA",
        },
        {
            dataField: "DS_ETAPA",
            text: "ETAPA VISTORIA",
        },
        {
            dataField: "DT_CORTE_INICIO",
            text: "Dt. Início Corte",
            formatter: (c) => (c ? moment(c).format("DD/MM/yy") : "-"),
        },
        {
            dataField: "DT_CORTE_FIM",
            text: "Dt. Fim Corte",
            formatter: (c) => (c ? moment(c).format("DD/MM/yy") : "-"),
        },
        {
            dataField: "DT_AGENDA",
            text: "Dt. Agendamento",
            formatter: (c) => (c ? moment(c).format("DD/MM/yy") : "-"),
        },
        {
            dataField: "PROCESSO_VISTORIA",
            text: "PROCESSO VISTORIA",
            isDummyField: true,
            formatExtraData: {},

            formatter: (_, row, index) => (
                <div className="Button-Tools d-flex justify-content-end align-items-center">
                    {!row.ID_CASO ? (
                        <>
                            <button
                                className="btn btn-light-dark font-weight-bold mr-2"
                                disabled={IniciarCasoLoading}
                                onClick={() => {
                                    IniciarCaso(
                                        row.ID_PRODUTO,
                                        row.ID_CONTA,
                                        row.ID_CONTATO
                                    ).then(() => {
                                        updateList();
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faPlay} size="lg" />{" "}
                                <span className="d-none d-sm-block">
                                    Iniciar Processo
                                </span>
                            </button>
                            <button
                                className="btn btn-light-dark font-weight-bold mr-2"
                                disabled={AdcorpusLoading}
                                onClick={() => {
                                    AdcorpusCaso(
                                        row.ID_PRODUTO,
                                        row.ID_CONTA,
                                        row.ID_CONTATO
                                    ).then(() => {
                                        updateList();
                                    });
                                }}
                            >
                                <span className="d-none d-sm-block">
                                    Ad Corpus
                                </span>
                            </button>
                        </>
                    ) : (
                        <>
                            {emccampMode === ID_ORGANIZACAO && (
                                <button
                                    className="btn btn-light-info mr-2"
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent: "Gerar Documentos",
                                            IconHeader: faPrint,
                                            Component: () => (
                                                <GerarDocumentoGestaoVistoria
                                                    setShow={setShow}
                                                    row={row}
                                                />
                                            ),
                                            size: "sm",
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPrint} /> Gerar
                                    Documentos
                                </button>
                            )}

                            {!listarFormulariosVistoria?.Vistorias?.[index]
                                .FL_PARALISADO ? (
                                <button
                                    className="btn btn-light-warning font-weight-bold mr-2"
                                    disabled={ParalisarLoading}
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent: "Paralisar Caso",
                                            IconHeader: faPause,
                                            Component: () => (
                                                <>
                                                    <UnForm
                                                        handleSubmit={(
                                                            formData
                                                        ) => {
                                                            ParalisarCaso(
                                                                row.ID_CASO,
                                                                formData.ID_MOTIVO_NAO_PROCEDENCIA
                                                            ).then(() => {
                                                                updateList();
                                                                setShow(false);
                                                            });
                                                        }}
                                                    >
                                                        <UnForm.LazySelect
                                                            label="Motivo Não Procedência"
                                                            name="ID_MOTIVO_NAO_PROCEDENCIA"
                                                            controller={() =>
                                                                MotivoNaoProcedenciaController(
                                                                    row.ID_CASO
                                                                )
                                                            }
                                                            getDS={(ca) =>
                                                                ca.DS_MOTIVO_NAO_PROCEDENCIA
                                                            }
                                                            getKeyValue={(p) =>
                                                                p.ID_MOTIVO_NAO_PROCEDENCIA
                                                            }
                                                            registerOptions={{
                                                                required:
                                                                    "Insira um motivo antes de paralisar",
                                                                valueAsNumber:
                                                                    true,
                                                            }}
                                                            className="form-control mb-2"
                                                        />
                                                        <button className="btn btn-outline-success w-100 mt-3">
                                                            Paralisar
                                                        </button>
                                                    </UnForm>
                                                </>
                                            ),
                                            size: "lg",
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPause} size="lg" />{" "}
                                    <span className="d-none d-sm-block">
                                        Paralisar
                                    </span>
                                </button>
                            ) : (
                                <button
                                    className="btn btn-light-primary font-weight-bold mr-2 cursor-default"
                                    disabled={ReiniciarLoading}
                                    onClick={() => {
                                        ReiniciarCaso(row.ID_CASO).then(() => {
                                            updateList();
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPause} size="lg" />{" "}
                                    <span className="d-none d-sm-block">
                                        Reiniciar
                                    </span>
                                </button>
                            )}
                            {row.DT_FIM === null ? (
                                <button
                                    className="btn btn-light-danger font-weight-bold mr-2"
                                    disabled={
                                        ReagendarLoading ||
                                        listarFormulariosVistoria?.Vistorias?.[
                                            index
                                        ].FL_PARALISADO
                                    }
                                    onClick={() => {
                                        ReagendarCaso(row.ID_CASO).then(() => {
                                            updateList();
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faCalendar}
                                        size="lg"
                                    />{" "}
                                    <span className="d-none d-sm-block">
                                        Reagendar
                                    </span>
                                </button>
                            ) : (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="overlay-tooltip">
                                            Atendimento finalizado
                                        </Tooltip>
                                    }
                                >
                                    <span className="d-inline-block">
                                        <Button
                                            className="btn btn-light-danger font-weight-bold mr-2"
                                            disabled={
                                                row.DT_FIM !== null ||
                                                listarFormulariosVistoria
                                                    ?.Vistorias?.[index]
                                                    .FL_PARALISADO
                                            }
                                            style={{ pointerEvents: "none" }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faCalendar}
                                                size="lg"
                                            />{" "}
                                            <span className="d-none d-sm-block">
                                                Reagendar
                                            </span>
                                        </Button>
                                    </span>
                                </OverlayTrigger>
                            )}
                            <button
                                className="btn btn-light-success font-weight-bold mr-2"
                                disabled={
                                    enviarEmailLoading ||
                                    listarFormulariosVistoria?.Vistorias?.[
                                        index
                                    ].FL_PARALISADO
                                }
                                onClick={() => {
                                    EnviarEmail(row.ID_CASO).then(() => {
                                        updateList();
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faAt} size="lg" />{" "}
                                <span className="d-none d-sm-block">
                                    Reenviar Email
                                </span>
                            </button>
                        </>
                    )}
                </div>
            ),
        },
    ];
    const ultimaPesquisaRef = useRef("");

    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    PESQUISA: newState.searchText,
                    PAGINA: newState.page,
                });
                setPage(newState.page);
            }
        }, 1500);
    }

    return (
        <FormProvider {...FormMethods}>
            <div className="card card-custom p-10">
                <div>
                    <div className="d-flex justify-content-end mb-2">
                        {emccampMode === ID_ORGANIZACAO && (
                            <button
                                className="btn btn-light-info mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Gerar Documentos",
                                        IconHeader: faPrint,
                                        Component: () => (
                                            <GerarDocumentoGestaoVistoria
                                                setShow={setShow}
                                                lstSelecionados={
                                                    lstSelecionados
                                                }
                                            />
                                        ),
                                        size: "sm",
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faPrint} /> Gerar
                                Documentos
                            </button>
                        )}

                        <button
                            className="btn btn-success"
                            disabled={
                                !lstSelecionados ||
                                lstSelecionados?.Vistorias.length === 0 ||
                                LiberacaoCasosVistoriaEmMassaLoading
                            }
                            onClick={() => {
                                Swal.fire({
                                    title: `Deseja fazer a liberação ${
                                        (lstSelecionados?.Vistorias.length ??
                                            0) > 1
                                            ? "dos"
                                            : "de"
                                    }  ${
                                        lstSelecionados?.Vistorias.length
                                    } caso${adicionaPlural} selecionado${adicionaPlural}?`,
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Sim!",
                                    showCancelButton: true,
                                    cancelButtonText:
                                        "<i class='la la-thumbs-down'></i> Não",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                        cancelButton: "btn btn-default",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        LiberacaoCasosVistoriaEmMassa(
                                            filteredVistorias
                                        ).then(() => {
                                            updateList();
                                            setLstSelecionados({
                                                Vistorias: [],
                                                NR_PAGINAS: 1,
                                            });
                                        });
                                    }
                                });
                            }}
                        >
                            {LiberacaoCasosVistoriaEmMassaLoading ? (
                                <Spinner color="primary" size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faCheck} />
                            )}{" "}
                            Liberar Casos
                        </button>
                    </div>
                    <Table
                        keyField="ID"
                        columns={atendimentoVistoriaColumns}
                        wrapperClasses="mw-100 custom-scroll"
                        tableView={{
                            columns: tableviewColumns,
                            sizePerPage: 10,
                            cancelYScroll: true,
                            defaultStyle: true,
                            striped: true,
                        }}
                        remote={{ pagination: true, filter: true }}
                        data={listarFormulariosVistoria?.Vistorias ?? []}
                        loading={listarFormulariosVistoriaLoading}
                        onTableChange={(_type, newState) => {
                            const state = newState as IPropsTableChange;

                            if (state.searchText !== "") {
                                handleSearch(state.searchText, state);
                                setPesquisaText(state.searchText);
                            } else if (pesquisaText.length > 0) {
                                setFilter({ PESQUISA: state.searchText });
                            } else {
                                setPage(state.page);
                            }
                        }}
                        totalPages={totalPaginas}
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhum Formulário Encontrado
                            </div>
                        )}
                        rowStyle={{ height: 50 }}
                        bordered={false}
                        defaultStyle={{ align: "center" }}
                        striped={true}
                        rowClasses={"rowClasses"}
                        noHover
                        center={true}
                        selectRow={{
                            mode: "checkbox",
                            selected: lstSelecionados?.Vistorias.map(
                                (vistoria) => vistoria.ID
                            ),
                            onSelect: (row, isSelect, rowIndex, e) => {
                                if (isSelect) {
                                    setLstSelecionados((prevSelec) => {
                                        return {
                                            Vistorias: [
                                                ...(prevSelec?.Vistorias ?? []),
                                                row as IGestaoVistoriaResponse["Vistorias"][0],
                                            ],
                                            NR_PAGINAS:
                                                prevSelec?.NR_PAGINAS ?? 1,
                                        };
                                    });
                                } else {
                                    setLstSelecionados((prevSelec) => {
                                        return {
                                            Vistorias:
                                                prevSelec?.Vistorias.filter(
                                                    (vistoria) =>
                                                        vistoria.ID !== row.ID
                                                ) ?? [],
                                            NR_PAGINAS:
                                                prevSelec?.NR_PAGINAS ?? 1,
                                        };
                                    });
                                }
                            },
                            onSelectAll: (isSelect, rows, e) => {
                                if (isSelect) {
                                    setLstSelecionados({
                                        Vistorias:
                                            rows as IGestaoVistoriaResponse["Vistorias"],
                                        NR_PAGINAS: 1,
                                    });
                                } else {
                                    setLstSelecionados({
                                        Vistorias: [],
                                        NR_PAGINAS: 1,
                                    });
                                }
                            },
                        }}
                    />
                </div>
                <ModalComponent
                    show={show}
                    setShow={setShow}
                    ModalComponent={modal}
                />

                <FiltroEntregaChaves
                    handleSubmit={(formData) => {
                        setPageFilter({
                            filter: formData,
                            page: 1,
                        });
                    }}
                    storageManager={filterStorage}
                    defaultFilter={filter}
                    setIdEmpreendimento={setIdEmpreendimento}
                    idEmpreendimento={idEmpreendimento}
                />
            </div>
        </FormProvider>
    );
}
